import { extendTheme } from '@chakra-ui/react';
import { Global } from '@emotion/react';

import { SkipLink } from './ComponentsTheme/SkipLink.Theme';
import { Header } from './ComponentsTheme/Header.Theme';
import { SubHeader, SubHeaderItem } from './ComponentsTheme/SubHeader.Theme';
import { SelectField } from './ComponentsTheme/SelectField.Theme';
import { Button } from './ComponentsTheme/Button.Theme';
import { Divider } from './ComponentsTheme/Divider.Theme';
import { Page } from './ComponentsTheme/Page.Theme';
import { Container } from './ComponentsTheme/Container.Theme';
import { PageContainer } from './ComponentsTheme/PageContainer.Theme';
import {
  AccordionDetailsPanel,
  AccordionDetailsItem,
  AccordionDetailsButton,
} from './ComponentsTheme/AccordionDetails.Theme';
import { RangeField } from './ComponentsTheme/RangeField.Theme';
import { ButtonTray } from './ComponentsTheme/ButtonTray.Theme';
import { Slider } from './ComponentsTheme/Slider.Theme';
import { NumberUnitField } from './ComponentsTheme/NumberUnitField.Theme';
import { NumberUnitsField } from './ComponentsTheme/NumberUnitsField.Theme';
import { SectionIntro } from './ComponentsTheme/SectionIntro.Theme';
import { Radio } from './ComponentsTheme/Radio.Theme';
import { FieldArray } from './ComponentsTheme/FieldArray.Theme';
import { PageSectionHeading } from './ComponentsTheme/PageSectionHeading.Theme';
import { Heading } from './ComponentsTheme/Heading.Theme';
import { CTA } from './ComponentsTheme/CTA.Theme';
import { CheckboxesGroup } from './ComponentsTheme/CheckboxesGroup.Theme';
import { BoostActive } from './ComponentsTheme/BoostActive.Theme';
import { BoostInactive } from './ComponentsTheme/BoostInactive.Theme';
import { Checkbox } from './ComponentsTheme/Checkbox.Theme';
import { InfoTooltip } from './ComponentsTheme/InfoTooltip.Theme';

export const brandColours = {
  // DEVELOPER NOTE:
  // Naming convention of lowercase colour names please
  lightgreen: '#BEDBBB',
  lightgreen2: '#E1F4E3',
  green: '#2aa43c',
  darkgreen: '#0a6a0c',
  greenywhite: '#7fc88a',
  darkgrey: '#1E2022',
  grey: '#404040',
  midgrey: '#797979',
  midgrey2: '#979797',
  lightgrey: '#c4c4c4',
  lightgrey2: '#e5e5e5',
  lightgrey3: '#f9f9f9',
  white: '#fff',
  black: '#000',
  red: '#f00',
  pink: '#ffe2e2',
};

export const CarbonClickTheme = extendTheme({
  components: {
    SkipLink,
    Header,
    SubHeader,
    SubHeaderItem,
    AccordionDetailsPanel,
    AccordionDetailsItem,
    AccordionDetailsButton,
    SelectField,
    ButtonTray,
    Button,
    Slider,
    Divider,
    Checkbox,
    Page,
    PageContainer,
    Container,
    RangeField,
    NumberUnitField,
    SectionIntro,
    FieldArray,
    Radio,
    NumberUnitsField,
    PageSectionHeading,
    Heading,
    CTA,
    CheckboxesGroup,
    BoostActive,
    BoostInactive,
    InfoTooltip,
    Link: { baseStyle: { textDecoration: 'underline' } },
  },
  styles: {
    global: {
      body: {
        bg: 'brand.lightgrey2',
        color: 'brand.black',
        paddingBottom: '70px',
        fontFamily: "'Open Sans', Raleway, sans-serif",
      },
    },
  },
  colors: {
    brand: { ...brandColours },
  },
});

export const CarbonClickGlobal = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 300;
        src: local('Open Sans'), local('OpenSans'), url('./OpenSans-Light.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        src: local('Open Sans'), local('OpenSans'), url('./OpenSans-SemiBold.woff2') format('woff2');
      }

      abbr[title] {
        text-decoration: none;
        border: none;
      }


      html[data-whatintent='mouse'] *:focus,
      html[data-whatintent='touch'] *:focus {
        outline: none;
        box-shadow: none;
      }
      `}
  />
);
